import { TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

const IGNORE_TITLECASE_VALUE = ['N/A', 'COD'];
const UPPERCASE_WORDS = ['NE', 'NW', 'SE', 'SW', 'N', 'S', 'E', 'W'];

@Pipe({
    name: 'titlecaseFormat'
})
export class TitlecaseFormatPipe implements PipeTransform {
    constructor(private titleCase: TitleCasePipe) {}

    transform(value: string): string {
        if (value) {
            if (IGNORE_TITLECASE_VALUE.find(e => e === value.toUpperCase())) {
                return value.toUpperCase();
            } else {
                return this.titleCase.transform(value)
                    .split(' ')
                    .map(word => UPPERCASE_WORDS.includes(word.toUpperCase()) ? word.toUpperCase() : word)
                    .join(' ');
            }
        }
        return '';
    }
}
